export enum ZustandStores {
  INBOX_ENTRIES = 'inbox-entries',
  PLATFORM_STATE = 'platform-state',
  USER_COMMUNICATIONS = 'user-communications',
  SLACK_COMMUNICATIONS = 'slack-communications',
  TEAMS_COMMUNICATIONS = 'teams-communications',
  INSTAGRAM_COMMUNICATIONS = 'instagram-communications',
  SELECTED_ITEMS = 'selected-items',
  INBOX_LABELS = 'inbox-labels',
  INTEGRATIONS = 'integrations',
  DOBOX_DROPDOWN_STATES = 'dobox-dropdown-states',
  ONBOARDING_STORE = 'onboarding-store',
  DOBOX_PREFERENCES = 'dobox-preferences',
  USER_COMMUNICATION_INTENTS = 'user-communication-intents',
  INTEGRATION_PREFERENCES = 'integration-preferences',
  MESSAGE_DIALOG = 'message-dialog',
  DELEGATION_COMPOSER = 'delegation-composer',
}
